module.exports = __webpack_public_path__ + "img/猫耳朵.f9ee7bfc.gif";